import { cn } from "@/lib/utils";

interface MascotProps {
  /** e.g. "surggie_3" or "ceo_1" — maps to /assets/surggies/char_<spriteKey>.png */
  spriteKey: string;
  /** scale multiplier; 1 = native 16x32. Default 5 (=> 80x160 box). */
  scale?: number;
  /** apply the gentle .float-bob animation. Default true. */
  bob?: boolean;
  className?: string;
}

/**
 * Mascot — crops the down-facing idle frame (top-left 16x32) from a 64x128
 * character sheet and renders it scaled with pixelated rendering.
 *
 * Sheet layout: 64x128 = 4 cols x 4 rows of 16x32 frames. Down-facing idle is
 * the top-left frame (col 0, row 0). We render a fixed-size overflow box and use
 * background cropping so only that frame shows. SSR-safe (no client hooks).
 */
export function Mascot({ spriteKey, scale = 5, bob = true, className }: MascotProps) {
  const w = 16 * scale;
  const h = 32 * scale;
  return (
    <div
      aria-hidden="true"
      className={cn("inline-block", bob && "float-bob", className)}
      style={{
        width: `${w}px`,
        height: `${h}px`,
        backgroundImage: `url(/assets/surggies/char_${spriteKey}.png)`,
        // sheet is 64x128 native -> scale up the whole sheet by `scale`
        backgroundSize: `${64 * scale}px ${128 * scale}px`,
        // top-left frame: no offset
        backgroundPosition: "0 0",
        backgroundRepeat: "no-repeat",
        imageRendering: "pixelated",
      }}
    />
  );
}

export default Mascot;
